export default __webpack_public_path__ + "static/media/man-right2.6423d2f1.png";